var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DFFAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3171 13.1828C25.5611 13.4269 25.5611 13.8226 25.3171 14.0667L16.5671 22.8167C16.323 23.0608 15.9273 23.0608 15.6832 22.8167L11.3082 18.4417C11.0641 18.1976 11.0641 17.8019 11.3082 17.5578C11.5523 17.3137 11.948 17.3137 12.1921 17.5578L16.1251 21.4909L24.4332 13.1828C24.6773 12.9387 25.073 12.9387 25.3171 13.1828Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStick);
export default __webpack_public_path__ + "static/media/stick.34c0208f5ccde9f319a433bcbcc89bc4.svg";
export { ForwardRef as ReactComponent };